// import { ROUTES } from "../utils/constants";

export const NullishValues = ["", undefined, null, 0, NaN];

export const MeetingTypes = [
  {
    displayName: "Discussion",
    value: "DISCUSSION_MEETING",
  },
  {
    displayName: "Gosho",
    value: "GOSHO_MEETING",
  },
  // {
  //   displayName: "NHR",
  //   value: "NHR_MEETING",
  // },
];

export const AppliedFilterLabelMap = {
  memberId: "Member ID",
  fullName: "Member Name",
  roleId: "Role Id",
  roleName: "Role Name",
  mobileNumber: "Phone Number",
  emailId: "Email Id",
  address: "Address",
  pincode: "Pin Code",
  state: "State",
  city: "City",
  divisionId: "Division",
  subdivisionId: "Sub Division",
  specialGroupId: "Special Group",
  dateOfBirth: "Date of Birth",
  dateOfJoining: "Date of Joining",
  profession: "Profession",
  professionSpecialGroup: "Profession Special Group",
  appointmentFrom: "Appointment Date",
  positions: "Positions",
  mainlinePositions: "Mainline Position",
  subLeadershipPosition: "Subdivision Leadership Position",
  subDivisionAppointmentFrom: "Sub-Division Appointment Date",
  isGohonzon: "Gohonzon Member",
  conferralFrom: "Conferral Date",
  isOmamoriGohonzon: "Omamori Gohonzon",
  unsubscribe: "Unsubscribe (Wrong Email ID)",
  areaId: "Area",
  clusterId: "Cluster",
  zoneId: "Zone",
  regionId: "Region",
  chapterId: "Chapter",
  districtId: "District",
  blockId: "Block",
  application: "Application Date",
  allotment: "Allotment Date",
  conferred: "Conferred Date",
};

export const DATES = [
  "dateOfBirthFrom",
  "dateOfJoiningFrom",
  "dateFrom",
  "appointedAtFrom",
  "conferralDateFrom",
  "applicationFrom",
  "allotmentFrom",
  "conferredFrom",
];
export const EXCLUDE_DATES = [
  "dateOfBirthTo",
  "dateOfJoiningTo",
  "dateTo",
  "appointedAtTo",
  "conferralDateTo",
  "applicationTo",
  "allotmentTo",
  "conferredTo",
];
export const ALL_DATES = [...DATES, ...EXCLUDE_DATES];
export const EVENT_NAME = "close-popover";

export const OS_DROPDOWN_KEYS = [
  "areaId",
  "clusterId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
  "blockId",
];

export const DROPDOWN_KEYS = ["city", "state", "divisionId", "subdivisionId"];

export const OS_REDUX_KEY_MAPPER = {
  areaId: "clusters",
  clusterId: "zones",
  zoneId: "regions",
  regionId: "chapters",
  chapterId: "districts",
  districtId: "blocks",
};

export const DROPDOWN_REDUX_KEY_MAPPER = {
  areaId: "areas",
  clusterId: "clusters",
  zoneId: "zones",
  regionId: "regions",
  chapterId: "chapters",
  districtId: "districts",
  blockId: "blocks",
  city: "cities",
  state: "states",
  divisionId: "divisions",
  subdivisionId: "subDivisions",
};

export const TRANSFER_OS_DROPDOWN_KEYS = [
  "initiatorAreaId",
  "initiatorClusterId",
  "initiatorZoneId",
  "initiatorRegionId",
  "initiatorChapterId",
  "initiatorDistrictId",
  "initiatorBlockId",
  "targetAreaId",
  "targetClusterId",
  "targetZoneId",
  "targetRegionId",
  "targetChapterId",
  "targetDistrictId",
  "targetBlockId",
];

export const TRANSFER_DROPDOWN_REDUX_KEY_MAPPER = {
  initiatorAreaId: "areas",
  initiatorClusterId: "clusters",
  initiatorZoneId: "zones",
  initiatorRegionId: "regions",
  initiatorChapterId: "chapters",
  initiatorDistrictId: "districts",
  initiatorBlockId: "blocks",
  targetAreaId: "areas",
  targetClusterId: "clusters",
  targetZoneId: "zones",
  targetRegionId: "regions",
  targetChapterId: "chapters",
  targetDistrictId: "districts",
  targetBlockId: "blocks",
  city: "cities",
  state: "states",
  divisionId: "divisions",
  subdivisionId: "subDivisions",
};

export const OS_KEYS = [
  "districtId",
  "chapterId",
  "regionId",
  "zoneId",
  "clusterId",
  "areaId",
];

export const FULL_OS_KEYS = [
  "blockId",
  "districtId",
  "chapterId",
  "regionId",
  "zoneId",
  "clusterId",
  "areaId",
];

export const CHEIF_ACCESS_MAP = {
  districtSI: "districtSI",
  chapterSI: "chapterSI",
  regionSI: "regionSI",
  zoneSI: "zoneSI",
  clusterSI: "clusterSI",
  areaSI: "areaSI",
  helpDesk: "helpDesk",
  districtLeader: "districtLeader",
  chapterLeader: "chapterLeader",
  regionLeader: "regionLeader",
  zoneLeader: "zoneLeader",
  clusterLeader: "clusterLeader",
  areaLeader: "areaLeader",
};

export const ChiefSIToIdMapper = {
  districtSI: "districtId",
  chapterSI: "chapterId",
  regionSI: "regionId",
  zoneSI: "zoneId",
  clusterSI: "clusterId",
  areaSI: "areaId",
};

export const ROLES_KEY_MAPPER = {
  districtSI: OS_KEYS.reverse(),
  districtLeader: OS_KEYS.reverse(),
  districtDeputySI: OS_KEYS.reverse(),
  chapterSI: OS_KEYS.slice(0, -1),
  chapterLeader: OS_KEYS.slice(0, -1),
  chapterDeputySI: OS_KEYS.slice(0, -1),
  regionSI: OS_KEYS.slice(0, -2),
  regionLeader: OS_KEYS.slice(0, -2),
  regionDeputySI: OS_KEYS.slice(0, -2),
  zoneSI: OS_KEYS.slice(0, -3),
  zoneLeader: OS_KEYS.slice(0, -3),
  zoneDeputySI: OS_KEYS.slice(0, -3),
  clusterSI: OS_KEYS.slice(0, -3),
  clusterLeader: OS_KEYS.slice(0, -3), // change krna hai
  clusterDeputySI: OS_KEYS.slice(0, -3),
  areaSI: OS_KEYS.slice(0, -4),
  areaLeader: OS_KEYS.slice(0, -4),
  areaDeputySI: OS_KEYS.slice(0, -4),
  helpDesk: [],
};

export const INTEGER_KEYS = [
  "memberId",
  "pincode",
  "state",
  "city",
  "divisionId",
  "subdivisionId",
  "specialGroupId",
];

export const GOHONZON_TYPE_OPTIONS = [
  {
    key: "GOHONZON",
    value: "OKATAKI_GOHONZON",
  },
  {
    key: "OMAMORI",
    value: "OMAMORI_GOHONZON",
  },
  {
    key: "SPECIAL",
    value: "SPECIAL_GOHONZON",
  },
];

export const GOHONZON_TYPE = {
  OKATAKI_GOHONZON: "OKATAKI_GOHONZON",
  OMAMORI_GOHONZON: "OMAMORI_GOHONZON",
  SPECIAL_GOHONZON: "SPECIAL_GOHONZON",
};

export const INTRODUCTION_TYPE = "introduction";
export const MEMBER_TYPE = "member";
export const FRIEND_TYPE = "friend";
export const ACTIVE = "ACTIVE";

export const DEACTIVATE_REASONS = [
  {
    displayName: "Eternal Comrades",
    value: "ETERNAL_COMRADES",
  },
  {
    displayName: "Not interested in practicing",
    value: "NOT_INTERESTED_IN_PRACTICING",
  },
  {
    displayName: "Not traceable",
    value: "NOT_TRACEABLE",
  },
  {
    displayName: "Overseas Comrades",
    value: "OVERSEAS_COMRADES",
  },
  {
    displayName: "Disciplinary Action",
    value: "DISCIPLINARY_ACTION",
  },
  {
    displayName: "Gohonzon Return",
    value: "GOHONZON_RETURN",
  },
  {
    displayName: "Duplicate entry",
    value: "DUPLICATE_ENTRY",
  },
];

export const MARK_ATTENDANCE = [
  // {
  //   displayName: "FAMILY ID",
  //   key: "familyId",
  // },
  {
    displayName: "AREA",
    key: "area",
  },

  {
    displayName: "CLUSTER",
    key: "cluster",
  },
  {
    displayName: "ZONE",
    key: "zone",
  },
  {
    displayName: "REGION",
    key: "region",
  },
  {
    displayName: "FAMILY MEMBERS",
    key: "familyAddress",
  },
  {
    displayName: "ADDRESS",
    key: "address",
  },
  {
    displayName: "ACTION",
    key: "action",
  },
];

export const Constants = {
  MIN_PAGE_SIZE: 5,
  MAX_PAGE_SIZE: 20,
  DEFAULT_PAGE_SIZE: 5,
  PLUS: "plus",
};

export const ConstantsAppointment = {
  MIN_PAGE_SIZE: 4,
  MAX_PAGE_SIZE: 20,
  DEFAULT_PAGE_SIZE: 4,
  PLUS: "plus",
};

export const OTP_LEN = 6;

export const RELATION_OPTIONS = [
  { key: "Husband", value: "HUSBAND" },
  { key: "Daughter", value: "DAUGHTER" },
  { key: "Son", value: "SON" },
  { key: "Wife", value: "WIFE" },
];

export const Appointment = {
  MAINLINE_POSITION: "MAINLINE_POSITION",
  DEPUTY_POSITION: "DEPUTY_POSITION",
};

export const ChiefNameToPositionMapper = {
  [CHEIF_ACCESS_MAP.districtSI]: [],
  [CHEIF_ACCESS_MAP.chapterSI]: [26, 50],
  [CHEIF_ACCESS_MAP.regionSI]: [29, 30],
  [CHEIF_ACCESS_MAP.zoneSI]: [27, 28],
  [CHEIF_ACCESS_MAP.clusterSI]: [27, 28], // change krna hai value
  [CHEIF_ACCESS_MAP.areaSI]: [51, 59],
};

// export const TABLE_ROUTES = [
//   ROUTES.INTRODUCTION_VIEW.path,
//   ROUTES.FRIEND_TRANSFER.path,
//   ROUTES.MEMBER_TRANSFER.path,
//   ROUTES.MEMBER_DETAIL.path,
//   ROUTES.FRIEND_DETAIL.path,
// ];

export const AlertStatus = {
  ERROR: "error",
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
};

export const [DROPDOWN, TEXTFIELD, TEXTLABEL, AUTOCOMPLETE] = [
  "dropdown",
  "textfield",
  "textlabel",
  "autocomplete",
];

export const MEMBER_OPTIONS = [
  { key: "Yes", value: "YES" },
  { key: "No", value: "NO" },
];

export const AppliedFilterFriendLabelMap = {
  friendId: "Friend ID",
  fullName: "Friend Name",
  mobileNumber: "Phone Number",
  emailId: "Email Id",
  address: "Address",
  pincode: "Pin Code",
  state: "State",
  city: "City",
  divisionId: "Division",
  subdivisionId: "Sub Division",
  dateOfBirth: "Date of Birth",
  dateOfJoining: "Date of Joining",
  profession: "Profession",
  professionSpecialGroup: "Profession Special Group",
  appointmentFrom: "Appointment Date",
  positions: "Positions",
  mainlinePositions: "Mainline Position",
  subLeadershipPosition: "Subdivision Leadership Position",
  subDivisionAppointmentFrom: "Sub-Division Appointment Date",
  isGohonzon: "Gohonzon Member",
  conferralFrom: "Conferral Date",
  isOmamoriGohonzon: "Omamori Gohonzon",
  unsubscribe: "Unsubscribe (Wrong Email ID)",
  areaId: "Area",
  clusterId: "Cluster",
  zoneId: "Zone",
  regionId: "Region",
  chapterId: "Chapter",
  districtId: "District",
  blockId: "Block",
  initiatorAreaId: "Initiator Area",
  initiatorClusterId: "Initiator Cluster",
  initiatorZoneId: "Initiator Zone",
  initiatorRegionId: "Initiator Region",
  initiatorChapterId: "Initiator Chapter",
  initiatorDistrictId: "Initiator District",
  initiatorBlockId: "Initiator Block",
  targetAreaId: "Target Area",
  targetClusterId: "Target Cluster",
  targetZoneId: "Target Zone",
  targetRegionId: "Target Region",
  targetChapterId: "Target Chapter",
  targetDistrictId: "Target District",
  targetBlockId: "Target Block",
};

export const AppliedIntroductionFilterLabelMap = {
  introductionId: "Introduction ID",
  fullName: "Introduction Name",
  mobileNumber: "Phone Number",
  emailId: "Email Id",
  areaId: "Area",
  clusterId: "Cluster",
  zoneId: "Zone",
  regionId: "Region",
  chapterId: "Chapter",
  districtId: "District",
  blockId: "Block",
  initiatorAreaId: "Initiator Area",
  initiatorClusterId: "Initiator Cluster",
  initiatorZoneId: "Initiator Zone",
  initiatorRegionId: "Initiator Region",
  initiatorChapterId: "Initiator Chapter",
  initiatorDistrictId: "Initiator District",
  initiatorBlockId: "Initiator Block",
  targetAreaId: "Target Area",
  targetClusterId: "Target Cluster",
  targetZoneId: "Target Zone",
  targetRegionId: "Target Region",
  targetChapterId: "Target Chapter",
  targetDistrictId: "Target District",
  targetBlockId: "Target Block",
};

export const AppliedMemberFilterLabelMap = {
  memberId: "Member ID",
  fullName: "Member Name",
  mobileNumber: "Phone Number",
  emailId: "Email Id",
  areaId: "Area",
  clusterId: "Cluster",
  zoneId: "Zone",
  regionId: "Region",
  chapterId: "Chapter",
  districtId: "District",
  blockId: "Block",
  initiatorAreaId: "Initiator Area",
  initiatorClusterId: "Initiator Cluster",
  initiatorZoneId: "Initiator Zone",
  initiatorRegionId: "Initiator Region",
  initiatorChapterId: "Initiator Chapter",
  initiatorDistrictId: "Initiator District",
  initiatorBlockId: "Initiator Block",
  targetAreaId: "Target Area",
  targetClusterId: "Target Cluster",
  targetZoneId: "Target Zone",
  targetRegionId: "Target Region",
  targetChapterId: "Target Chapter",
  targetDistrictId: "Target District",
  targetBlockId: "Target Block",
};
export const AppliedFilterLabelMapEmailer = {
  id: "Member ID",
  fullName: "Member Name",
  // roleId: "Role Id",
  // roleName: "Role Name",
  mobileNumber: "Phone Number",
  emailId: "Email Id",
  addressLine1: "Address",
  pincode: "Pin Code",
  stateId: "State",
  cityId: "City",
  divisionId: "Division",
  subdivisionId: "Sub Division",
  dateOfBirth: "Date of Birth",
  dateOfJoining: "Date of Joining",
  appointedAt: "Appointment Date",
  professionIds: "Profession",
  professionSpecialGroup: "Profession Special Group",
  appointmentFrom: "Appointment Date",
  dualPositionIds: "Dual Positions",
  mainlinePositionIds: "Mainline Position",
  subLeadershipPosition: "Subdivision Leadership Position",
  subDivisionAppointmentFrom: "Sub-Division Appointment Date",
  isGohonzon: "Gohonzon Member",
  gohonzonTypes: "Gohonzon Types",
  conferralDate: "Conferral Date",
  isOmamoriGohonzon: "Omamori Gohonzon",
  unsubscribe: "Unsubscribe (Wrong Email ID)",
  areaId: "Area",
  clusterId: "Cluster",
  zoneId: "Zone",
  regionId: "Region",
  chapterId: "Chapter",
  districtId: "District",
  blockId: "Block",
};

export const GOHONZON_TRANSACTION_TYPE_OPTIONS = [
  {
    key: "Allotment",
    value: "ALLOTMENT",
  },
  {
    key: "Retuened Non Conferral",
    value: "RETURNED_NON_CONFERRAL",
  },
  {
    key: "Returned Others",
    value: "RETURNED_OTHERS",
  },
  {
    key: "Replacement",
    value: "REPLACEMENT",
  },
  {
    key: "Addition HQ",
    value: "ADDITION_HQ",
  },
];

export const GOHONZON_OPTIONS = [
  {
    key: "Gohonzon",
    value: "OKATAKI_GOHONZON",
  },
  {
    key: "Omamori",
    value: "OMAMORI_GOHONZON",
  },
  {
    key: "Special",
    value: "SPECIAL_GOHONZON",
  },
];
